import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";

export default function TimesheetFilters({
  service,
  setService,
  language,
  setLanguage,
  services = [],
  languages = [],
}) {
  const filterWidth = 180;

  return (
    <Grid container spacing={2} style={{ marginBottom: 15 }}>
      {/* SERVICE FILTER */}
      <Grid item>
        <FormControl
          style={{ width: filterWidth }}
          variant="outlined"
          size="small"
        >
          <InputLabel>Service</InputLabel>

          <Select
            value={service}
            onChange={(e) => setService(e.target.value)}
            label="Service"
            renderValue={(selected) => (selected === "" ? "All" : selected)}
          >
            {/* All Option */}
            <MenuItem value="">All</MenuItem>

            {/* Dynamic Services */}
            {services.map((srv) => (
              <MenuItem key={srv} value={srv}>
                {srv}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      {/* LANGUAGE FILTER */}
      <Grid item>
        <FormControl
          style={{ width: filterWidth }}
          variant="outlined"
          size="small"
        >
          <InputLabel>Language</InputLabel>

          <Select
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            label="Language"
          >
            {/* All Option */}
            <MenuItem value="">All</MenuItem>

            {/* Dynamic Languages */}
            {languages.map((lang) => (
              <MenuItem key={lang} value={lang}>
                {lang}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}

TimesheetFilters.propTypes = {
  service: PropTypes.string,
  setService: PropTypes.func,
  language: PropTypes.string,
  setLanguage: PropTypes.func,
  services: PropTypes.array,
  languages: PropTypes.array,
};